/*
 * © 2026 Snyk Limited
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiBom = exports.UploadRevision = exports.SCM = exports.Target = exports.Integration = exports.CustomBaseImages = exports.CLI = exports.PRChecks = exports.Code = exports.Fix = exports.SbomExport = exports.SbomTest = exports.OpenSourceUnmanaged = exports.OpenAPI = exports.IsolatedBuilds = exports.PurlVulnerabilityFetching = exports.Policies = exports.OpenSourceProjectIssues = exports.OpenSourceProjectSnapshots = exports.OpenSourceEcosystems = exports.Snyk = void 0;
exports.Snyk = require("./Snyk-error-catalog");
exports.OpenSourceEcosystems = require("./OpenSourceEcosystems-error-catalog");
exports.OpenSourceProjectSnapshots = require("./OpenSourceProjectSnapshots-error-catalog");
exports.OpenSourceProjectIssues = require("./OpenSourceProjectIssues-error-catalog");
exports.Policies = require("./Policies-error-catalog");
exports.PurlVulnerabilityFetching = require("./PurlVulnerabilityFetching-error-catalog");
exports.IsolatedBuilds = require("./IsolatedBuilds-error-catalog");
exports.OpenAPI = require("./OpenAPI-error-catalog");
exports.OpenSourceUnmanaged = require("./OpenSourceUnmanaged-error-catalog");
exports.SbomTest = require("./SbomTest-error-catalog");
exports.SbomExport = require("./SbomExport-error-catalog");
exports.Fix = require("./Fix-error-catalog");
exports.Code = require("./Code-error-catalog");
exports.PRChecks = require("./PRChecks-error-catalog");
exports.CLI = require("./CLI-error-catalog");
exports.CustomBaseImages = require("./CustomBaseImages-error-catalog");
exports.Integration = require("./Integration-error-catalog");
exports.Target = require("./Target-error-catalog");
exports.SCM = require("./SCM-error-catalog");
exports.UploadRevision = require("./UploadRevision-error-catalog");
exports.AiBom = require("./AiBom-error-catalog");
//# sourceMappingURL=error-catalog.js.map